import { Container } from './styles';

export function Header() {
  return (
    <Container> 
      <h1>Doge Clicker</h1>
    </Container>
  );
}